import { render, staticRenderFns } from "./PatAppointmentsAPage.vue?vue&type=template&id=5ea9b9db"
import script from "./PatAppointmentsAPage.vue?vue&type=script&lang=js"
export * from "./PatAppointmentsAPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports